// import {
//   FaStar,
//   FaHeart,
//   FaShoppingCart,
// } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";


// export default function ProductCard({

  
//   image,
//   name,
//   price,
// }) {
//    const navigate = useNavigate();
  
//   return (
//     <div className="bg-white rounded-2xl border overflow-hidden">

//       <img
//         src={image}
//         alt=""
//         className="w-full h-60 object-contain p-4"
//       />

//       <div className="p-4">

//         <h3 className="font-semibold">
//           {name}
//         </h3>

//         <div className="flex text-yellow-400 mt-2">
//           <FaStar />
//           <FaStar />
//           <FaStar />
//           <FaStar />
//           <FaStar />
//         </div>

//         <h2 className="text-red-500 text-2xl font-bold mt-3">
//           Rs-{price}
//         </h2>

//         <div className="flex gap-2 mt-4">

//          <button
//                         onClick={() => navigate(`/product/${product.id}`)}
//                         className="w-full mt-5 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-3 rounded-lg transition duration-300"
//                         >
//                         View Details
//                         </button>

//           <button className="border px-4 rounded-xl">
//             <FaHeart />
//           </button>

//         </div>
//       </div>
//     </div>
//   );
// }







import { FaStar, FaHeart } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function ProductCard({
  id,
  image,
  name,
  price,
  description,
}) {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-2xl border overflow-hidden shadow-md hover:shadow-xl transition">
      <img
        src={image}
        alt={name}
        className="w-full h-60 object-contain p-4"
      />

      <div className="p-4">
        <h3 className="font-semibold">{name}</h3>

        <div className="flex text-yellow-400 mt-2">
          <FaStar />
          <FaStar />
          <FaStar />
          <FaStar />
          <FaStar />
        </div>

        <h2 className="text-red-500 text-2xl font-bold mt-3">
          Rs {price}
        </h2>

        <div className="flex gap-2 mt-4">
          <button
            onClick={() => navigate(`/product/${id}`)}
            className="flex-1 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-3 rounded-lg"
          >
            View Details
          </button>

          <button className="border px-4 rounded-xl">
            <FaHeart />
          </button>
        </div>
      </div>
    </div>
  );
}